<template>
  <div class="weekslist">
    <div class="week_btm">
      <div class="week_head">
        <div class="title">
          <div>
            <i class="el-icon-date" @click="displayleft"></i>
            <span>周视图</span>
          </div>
          <div>
            <el-switch
              class="nav-rt-sw"
              v-model="switchVal"
              :width="33"
              active-color="#13ce66"
              inactive-color="#bbbbbc"
              @change="switchChang"
            >
            </el-switch>
            <span>显示已完成</span>
          </div>
        </div>
        <div class="time">
          <span>{{ headDate }}</span>
        </div>
        <!-- <div style="padding: 10px">
          <el-input v-model="input" placeholder="请输入任务"> </el-input>
        </div> -->
      </div>
      <el-carousel
        :interval="5000"
        :autoplay="false"
        arrow="never"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in 1" :key="index">
          <ul class="day_list_head">
            <li v-for="(item1, index1) in wtimes" :key="index1">
              <div class="day" @click="releasetodo(item1.date)">
                <div>
                  <span class="hao">{{ item1.showDate }}</span>
                  <span class="week">{{ item1.weekh }}</span>
                </div>
                <div>+</div>
              </div>
            </li>
          </ul>

          <!-- 日历部分 -->
          <ul class="day_list_area">
            <div class="event-bg">
              <li
                v-for="(list, idx) in wkdlist"
                :key="idx"
                :style="{
                  background: (idx + 1) % 2 == 1 ? '#ffffff' : '#E8E8EE',
                }"
              >
                <div
                  class="diary"
                  :class="!list1.task_status ? '' : 'untask'"
                  v-for="(list1, idx1) in list"
                  :key="idx1"
                  v-show="
                    switchVal
                      ? !list1.task_status || list1.task_status
                      : !list1.task_status
                  "
                  :style="{
                    backgroundColor:
                      list1.type == 0
                        ? 'rgba(236, 114, 89,.7)'
                        : list1.type == 1
                        ? 'rgba(246, 168, 1,.7)'
                        : list1.type == 2
                        ? 'rgba(183, 142, 252,.7)'
                        : 'rgba(144, 208, 52,.7)',
                  }"
                  @click="editing(list1)"
                >
                  <div class="diary_text">{{ list1.task_name }}</div>
                </div>
              </li>
            </div>

            <!-- <div class="event-data">
              <div
                class="data-evens"
                v-for="(item, index) in newTodoData"
                :key="index"
                v-show="
                  switchVal
                    ? !item.task_status || item.task_status
                    : !item.task_status
                "
              >
                <div
                  :class="!item.task_status ? '' : 'untask'"
                  :style="{
                    marginLeft: `${
                      (item.timeindex - 1 < 0 ? 6 : item.timeindex - 1) * 14.28
                    }%`,
                    width:
                      item.timeindex - 1 < 0
                        ? '14.28%'
                        : `${
                            (item.endtimeindex - (item.timeindex - 1)) * 14.28
                          }%`,
                    backgroundColor:
                      item.type == 0
                        ? 'rgba(236, 114, 89,.7)'
                        : item.type == 1
                        ? 'rgba(246, 168, 1,.7)'
                        : item.type == 2
                        ? 'rgba(183, 142, 252,.7)'
                        : 'rgba(144, 208, 52,.7)',
                  }"
                  @click="editing(item)"
                >
                  {{ item.task_name }}
                </div>
              </div>
            </div> -->
          </ul>
        </el-carousel-item>
      </el-carousel>
      <div class="btn up" @click="goLeft"><i class="el-icon-back"></i></div>
      <div class="btn down" @click="goRight"><i class="el-icon-right"></i></div>

      <el-drawer
        :visible.sync="drawer"
        :with-header="false"
        size="288px"
        :modal="false"
      >
        <rels-right
          :options="options"
          :value1="value1"
          :value2="value2"
          @weekapi="weekapi"
        ></rels-right>
      </el-drawer>
    </div>
    <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawermoth"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>
  </div>
</template>

<script>
import dateFunc from "../../util/dateFunc";
import leftNav from "../../components/content/leftNav";
import relsRight from "../../components/content/release.vue";
import bodys from "../../assets/vue-fullcalendar/components/body.vue";
export default {
  components: {
    relsRight,
    leftNav,
    bodys,
  },
  data() {
    return {
      currentDate: new Date(),

      //控制显示点击div
      flag: 1, //=1 显示div =2显示input
      type: 2,
      input: "",
      headDate: "",
      weekTime: "",
      wDays: [],
      wtimes: [],
      listData: [{}, {}, {}],
      //请求到的数据
      wkdlist: [],
      switchVal: true,
      //右侧添加栏
      drawer: false,
      value1: "",
      value2: "",
      drawermoth: false,
      options: {},

      newTodoData: [],
    };
  },
  created() {
    this.weekTime = new Date();

    this.dispatchEvent();
  },
  watch: {},
  computed: {},
  methods: {
    editing(list1) {
      // list1.flag = true;
      let obj = {
        ...list1,
        btnText: "修改",
      };
      this.value1 = list1.task_time;
      this.value2 = list1.task_endtime;
      this.options = obj;
      this.drawer = true;
      console.log(list1);
    },
    changgeweek(data) {
      console.log(data, "修改的数据");
      this.drawer = true;
    },
    //左边显示
    displayleft() {
      if (document.body.clientWidth <= 1200) {
        this.drawermoth = true;
      }
    },
    goLeft() {
      //算出上一周的今天;
      this.weekTime = this.changeDateRange(this.weekTime, -1);
      this.weekapi();
      //获取上一周的数组;
      this.dispatchEvent();
    },
    goRight() {
      // 算出下一周的今天;

      this.weekTime = this.changeDateRange(this.weekTime, 1);
      this.weekapi();
      //获取下一周的数组
      this.dispatchEvent();
    },
    // 算出下周的今天
    changeDateRange(date, num) {
      let dt = new Date(date);
      return new Date(dt.valueOf() + num * 7 * 24 * 60 * 60 * 1000);
    },

    // 查询周视图数据
    weekapi() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .weekday(this.getTime(this.weekTime), header)
        .then((res) => {
          console.log(res, "查询的周视图数据");
          this.drawer = false;
          this.wkdlist = res.data.result;
          // let data = res.data.result;
          // let data1 = [];
          // this.newTodoData = data1.concat(...data);
          // this.newTodoData.forEach((item) => {
          //   item.timeval = new Date(item.task_time).getTime();
          //   item.timeindex = new Date(item.task_time).getDay();
          //   if (item.task_endtime) {
          //     if (new Date(item.task_endtime) > new Date(this.wtimes[6].date)) {
          //       item.endtimeindex = new Date(this.wtimes[6].date).getDay();
          //     } else {
          //       item.endtimeindex = new Date(item.task_endtime).getDay();
          //     }
          //   } else {
          //     item.endtimeindex = new Date(item.task_time).getDay();
          //   }
          // });
          // this.newTodoData = this.newTodoData.sort((a, b) => {
          //   return a.timeval - b.timeval;
          // });
          // console.log(this.newTodoData, "新的数据");
        })
        .catch((err) => {});
    },
    //构造数据
    dispatchEvent() {
      //算出数组
      console.error(dateFunc.getDates(this.weekTime));
      let weekDays = dateFunc.getDates(this.weekTime);
      console.log(weekDays, "周数组");

      let wli = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
      //把周数组时间变成mm-dd样式的字符串，
      weekDays.forEach((e, index) => {
        e.date = dateFunc.format(e, "yyyy-MM-dd");
        e.showDate = dateFunc.format(e, "dd");
        e.weekh = dateFunc.format(e, "dd");
      });
      for (var i = 0; i < weekDays.length; i++) {
        weekDays[i].weekh = wli[i];
      }
      console.log(weekDays, "处理的日期数据");
      this.wtimes = weekDays;
      //根据每周第一天确定上面title显示的是几月
      this.headDate =
        this.wtimes[0].date.split("-")[0] +
        "/" +
        this.wtimes[0].date.split("-")[1];
      this.weekapi();
    },

    // 显示隐藏
    switchChang(e) {
      console.log(e, "点击的switch的值");
      this.switchVal = e;
    },
    getTime(date) {
      var seperator1 = "-";
      var seperator2 = ":";
      //以下代码依次是获取当前时间的年月日时分秒
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var minute = date.getMinutes();
      var hour = date.getHours();
      var second = date.getSeconds();
      //固定时间格式
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minute >= 0 && minute <= 9) {
        minute = "0" + minute;
      }
      if (second >= 0 && second <= 9) {
        second = "0" + second;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    releasetodo(day) {
      console.log(day, "电机周几");
      this.drawer = true;
      let obj = {
        btnText: "发布",
      };
      this.options = obj;
      this.value1 = day;
      this.value2 = day;
      console.log(day, "hhhhhhh");
    },
  },
};
</script>

<style  lang="scss" scoped>
.weekslist {
  width: 100%;
  background-color: var(--color-theme);
  height: 100%;
  margin: 0 auto;
  display: flex;

  .week_btm {
    width: 100%;
    height: 100%;
    position: relative;
    .week_head {
      .title {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        height: 40px;
        .nav-rt-sw {
          width: 50px;
          height: 16px;
        }
        .el-switch__core {
          height: 16px !important;
        }
        .el-switch__core::after {
          height: 13px !important;
          width: 13px !important;
        }
        > :first-child {
          i {
            font-size: 22px;
            margin-right: 10px;
          }
          span {
            font-size: 24px;
            font-weight: bold;
          }
        }
        > :last-child {
          display: flex;
          align-items: center;
          span {
            font-size: 18px;
            color: gray;
            margin-left: 10px;
          }
        }
      }
      .time {
        line-height: 30px;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
    }
    .el-carousel {
      height: calc(100% - 180px);
      padding: 10px;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
    }

    .day_list_head {
      display: flex;
      height: 52px;
      border-radius: 7.5px;
      overflow: hidden;
      margin-bottom: 8px;
      background: #ffffff;
      li {
        flex: 1;
        height: 100%;
        padding-top: 10px;
        .day {
          height: 35px;
          display: flex;
          justify-content: space-between;
          padding: 0 30px;
          align-items: center;
          border-right: 1px solid gainsboro;
          .hao {
            font-size: 19px;
            color: #333333;
            margin-right: 10px;
          }
          .week {
            font-size: 15px;
            color: #cacacc;
          }
          > :last-child {
            font-size: 25px;
          }
        }
      }
      > :last-child {
        .day {
          border: none;
        }
      }
    }
    .day_list_area {
      height: calc(100% - 60px);
      border-radius: 10px;
      padding: 5px 0;
      box-sizing: border-box;
      position: relative;
      overflow: auto;

      .event-bg {
        height: 100%;
        overflow: auto;
        display: flex;
        .diary {
          width: 100%;
          height: 30px;
          border-radius: 3px;
          color: #ffffff;
          .diary_text {
            font-size: 14px;
            line-height: 30px;
            font-family: PingFang-SC-Medium;
            margin: 4px 0;
            overflow: hidden; //超出部分隐藏
            text-overflow: ellipsis; //超出部分显示...
            padding: 0 5px 0 10px;
            box-sizing: border-box;
            white-space: nowrap;
          }
        }
        .untask {
          text-decoration: line-through;
          opacity: 0.6;
        }
        li {
          flex: 1;
          height: 100%;
          width: 14.28%;
          border-radius: 8px;
          padding: 10px 5px;
        }
      }

      .event-data {
        width: 100%;
        height: calc(100% - 60px);
        position: absolute;
        top: 0;
        .data-evens {
          width: 100%;
          height: 30px;
          margin: 5px 0;
          div {
            width: 14.28%;
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            color: #ffffff;
            border-radius: 8px;
            padding: 0 10px;
            box-sizing: border-box;
            white-space: nowrap;
            overflow: hidden; //超出部分隐藏
            text-overflow: ellipsis; //超出部分显示...
          }
          .untask {
            text-decoration: line-through;
            opacity: 0.6;
          }
        }
      }
    }
    .day_list_area::-webkit-scrollbar {
      width: 3px;
    }
    .day_list_area::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }

    .btn {
      position: absolute;
      z-index: 100;
      height: 36px;
      width: 36px;
      line-height: 36px;
      cursor: pointer;
      transition: 0.3s;
      border-radius: 50%;
      background-color: rgba(31, 45, 61, 0.11);
      color: #fff;
      text-align: center;
    }
    .up {
      left: 25px;
      top: 50%;
    }
    .down {
      right: 25px;
      top: 50%;
    }
  }
}
</style>